import { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { FaUser } from 'react-icons/fa';

import { useOnClickOutside } from 'hooks';

import PropTypes from 'prop-types';
import RoomsAdultsSearch from 'components/roomsAdultsSearch/RoomsAdultsSearch';

const BookingDropdownLite = ({ onChange, searchOptions }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bookingDropdownRef = useRef(null);

    const disableChildrenSearch = useSelector(
        (state) => state.miniBookingWidget?.data?.disableChildrenSearch
    );
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    let displayText = `${searchOptions.numberOfRooms} ${Lang?.Rooms}, ${searchOptions.adults} ${Lang?.Adults}`;

    if (!disableChildrenSearch) {
        displayText += `, ${searchOptions.children} ${Lang?.Children}`;
    }

    const handleClickOutside = useCallback(() => {
        setIsOpen(false);
    }, []);

    useOnClickOutside(bookingDropdownRef, handleClickOutside);
    return (
        <div className="ab-adults-container" ref={bookingDropdownRef}>
            <div className="ab-adults-inner" onClick={() => setIsOpen(!isOpen)}>
                <button
                    role="button"
                    className="ab-btn ab-adultsButton"
                    tabIndex="0"
                    aria-disabled="false"
                    type="button"
                >
                    <div className="ab-btn-container">
                        <div className="ab-btn-inner">
                            <div className="ab-adultsContent">
                                <span className="ab-userIcon">
                                    <span className="svg">
                                        <FaUser size={20} />
                                    </span>
                                </span>
                                <span
                                    className="ab-displayText"
                                    aria-label={displayText}
                                >
                                    {displayText}
                                </span>
                            </div>
                        </div>
                    </div>
                </button>
            </div>

            {isOpen && (
                <div
                    className="ab-adults-dropdown"
                    id="ab-adults-dropdown"
                    style={{
                        display: 'block',
                    }}
                >
                    <div className="ab-adults-dropdown-wrapper">
                        <RoomsAdultsSearch
                            Lang={Lang}
                            setSearchOptions={onChange}
                            searchOptions={searchOptions}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

BookingDropdownLite.propTypes = {
    onChange: PropTypes.func,
    searchOptions: PropTypes.object,
};

export default BookingDropdownLite;
